module.exports = __webpack_public_path__ + "img/8cffc43b519092d7c971eb29be23f230.png";